export const validateForm = (formData, validationRules) => {
  let isValid = true;
  const errors = {};

  // Normalizar los campos del formulario
  const normalizedFormData = {};
  for (const field in formData) {
    if (formData.hasOwnProperty(field)) {
      const value = formData[field];
      // Verificar si el valor es una cadena antes de normalizar
      normalizedFormData[field] =
        typeof value === 'string' ? value.normalize('NFC') : value;
    }
  }

  for (const fieldName in validationRules) {
    if (validationRules.hasOwnProperty(fieldName)) {
      const rules = validationRules[fieldName];
      const value = String(formData[fieldName]).trim();
      const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
      //const injectionPattern = /(?:<script.*?>.*?<\/script.*?>)|(?:<.*?on\w+=".*?">)|(?:javascript:.*)|(?:['";`]|--|\/\*|\*\/)|(?:\b(SELECT|INSERT|UPDATE|DELETE|DROP|EXEC|UNION|CREATE|ALTER|TRUNCATE|GRANT|REVOKE)\b)|(?:xp_cmdshell)|(?:\bOR\b.*?\b=\b.*?)/gi;

      for (const rule of rules) {
        if (rule.required && !value) {
          errors[fieldName] = rule.message;
          isValid = false;
          break;
        }
/*
        if (injectionPattern.test(value)) {
          errors[fieldName] = 'El campo contiene caracteres no validos';
          isValid = false;
          break;
        }
*/
        if (rule.pattern && !rule.pattern.test(value)) {
          errors[fieldName] = rule.message;
          isValid = false;
          break;
        }
        if (rule.customValidator && !rule.customValidator(value, formData)) {
          errors[fieldName] = rule.message;
          isValid = false;
          break;
        }

        if (!urlPattern.test(value) && rule.isURL ) {
          errors[fieldName] = 'Ingrese una URL valida';
          isValid = false;
          break;
        } 
        if (urlPattern.test(value) && rule.isURL === undefined) {
          errors[fieldName] = 'El campo no debe contener una URL';
          isValid = false;
          break;
        }
        
        
      }
    }
  }

  return { isValid, errors };
};

  